// ============================================================
// Staff Management Layout
// ============================================================
// Wraps all routes in the Staff Management module.

import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export function StaffManagementLayout() {
  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
    </Box>
  );
}
